import React, { useContext, useEffect } from "react";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import { useImmer } from "use-immer";

function LockButton(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const locked = appState.status[props.parentIdx].locked;

  useEffect(() => {
    localStorage.setItem(
      `${appState.livre.isbn}-chapter-${props.parentIdx}-locked`,
      appState.status[props.parentIdx].locked
    );
  }, [appState.lockCounter]);

  function handleLockClick(e) {
    if (!props.disabled) {
      appDispatch({
        type: "UPDATE_CHAPTER_LOCK_STATUS",
        parentIdx: props.parentIdx,
      });
    }
  }

  return (
    <button
      className={
        `btn btn-sm btn-lock ` + (locked ? "btn-disabled" : "btn-primary")
      }
      onClick={(e) => handleLockClick(e)}
      disabled={props.readOnly ? "disabled" : false}
    >
      <span className="visually-hidden">
        {locked ? "Déverrouiller" : "Verrouiller"}
      </span>
    </button>
  );
}

export default LockButton;
